import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit sandbox on a 2x2 tile patch: a 1.8 x 1.8 m square of four plank
// rim boards around a sand slab, with a small toy bucket in one corner.
const PLANK = "#c8975a";
const SAND = "#d8c48f";
const BLUE = "#7a93a8";

const SIZE = 1.8;
const BOARD_T = 0.12;
const BOARD_H = 0.25;
const INNER = SIZE - 2 * BOARD_T;

export const sandbox = defineModel({
  id: "sandbox",
  batchId: "modern",
  name: "Sandbox",
  tags: ["modern", "outdoor", "playground", "kids", "garden", "sandbox"],
  summary: "A square plank sandbox with sand and a toy bucket.",
  description:
    "A kids sandbox of the Modern Living kit on a 2x2 tile patch: a 1.8 x " +
    "1.8 m square of plank rim boards, a sand fill at 0.15 m and a small " +
    "blue toy bucket in one corner.",
  tiles: { w: 2, h: 2 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // Rim boards: two full-length along X, two shorter along Z between them.
      {
        geometry: new THREE.BoxGeometry(SIZE, BOARD_H, BOARD_T),
        color: PLANK,
        position: [0, BOARD_H / 2, -(SIZE - BOARD_T) / 2],
      },
      {
        geometry: new THREE.BoxGeometry(SIZE, BOARD_H, BOARD_T),
        color: PLANK,
        position: [0, BOARD_H / 2, (SIZE - BOARD_T) / 2],
      },
      {
        geometry: new THREE.BoxGeometry(BOARD_T, BOARD_H, INNER),
        color: PLANK,
        position: [-(SIZE - BOARD_T) / 2, BOARD_H / 2, 0],
      },
      {
        geometry: new THREE.BoxGeometry(BOARD_T, BOARD_H, INNER),
        color: PLANK,
        position: [(SIZE - BOARD_T) / 2, BOARD_H / 2, 0],
      },
      // Sand fill, top surface at 0.15.
      {
        geometry: new THREE.BoxGeometry(INNER, 0.1, INNER),
        color: SAND,
        position: [0, 0.1, 0],
      },
      // Toy bucket in one corner, sitting on the sand.
      {
        geometry: new THREE.CylinderGeometry(0.08, 0.06, 0.12, 8),
        color: BLUE,
        position: [0.58, 0.21, 0.58],
      },
    ];
  },
  animations: [],
});
